import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const EnclosureWithCombinedTitleWidgetStaticSchema = BaseWidgetSchema(
  WidgetType.EnclosureWithCombinedTitle
).extend({
  style: z.record(z.unknown())
});

export type EnclosureWithCombinedTitleWidgetStaticSchemaType = z.infer<
  typeof EnclosureWithCombinedTitleWidgetStaticSchema
>;
